import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

// components
import FooterAuth from "components/Footers/Auth/FooterAuth.js";
// texts
import footerauth from "_texts/auth/footers/footerauth.js";

const IOSBadge = styled.div`
  background-image: url(https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png);
  display: block;
  margin-top: 1.5em;
  margin-bottom: 1em;
  width: 160px;
  height: 54px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;

const GooglePlayBadge = styled.div`
  background-image: url(https://lh3.googleusercontent.com/RyLoNcOmb91IxHIP9NWfC82chbsCsT-5R25efns1FmuM8xz6znE4CRjIEBosZ1FH2xG1UqH6Axyp-vPFnm4sazbrsaB-S0QT_cN9uWU9UKoSQYCjYQ=s0);
  display: block;
  margin-top: 1.5em;
  margin-bottom: 1em;
  width: 184px;
  height: 54px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;

const BodyText = styled.div`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const ParentingTrick = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <main>
        <section className="relative w-full h-full min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-black bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/bg-agentwire2.png").default + ")",
            }}
          ></div>
          <div
            style={{
              width: "100vw",
              height: "100vh",
              position: "relative",
              zIndex: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                height: "80%",
                backgroundColor: "white",
                borderRadius: "20px",
                display: "flex",
                flexDirection: "row",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  margin: "20px 0px 20px 20px",
                  height: "calc(100% - 40px)",
                  overflow: "hidden",
                  flex: 3,
                }}
              >
                <img
                  src={require("assets/img/parenting-trick.png").default}
                  alt="Esther standing"
                />
                <div>
                  <h1 style={{ fontWeight: 700, fontSize: "28px" }}>
                    Parenting TRICK
                  </h1>
                </div>
              </div>
              <div style={{ flex: 9, padding: "20px", overflowY: "auto" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <IOSBadge
                    onClick={() => {
                      window.open(
                        "https://apps.apple.com/us/app/parenting-trick/id6472183489",
                        "_blank"
                      );
                    }}
                  />
                  <GooglePlayBadge
                    style={{ marginLeft: "20px" }}
                    onClick={() => {
                      window.open(
                        "https://play.google.com/store/apps/details?id=com.agentwire.parentingtrick",
                        "_blank"
                      );
                    }}
                  />
                </div>
                <h1 style={{ fontWeight: 700, fontSize: "28px" }}>Welcome</h1>
                <BodyText>
                  Hello and welcome! I'm Esther Wojcicki, the creator of
                  Parenting TRICK, a new app that aims to revolutionize the way
                  we approach parenting.
                </BodyText>
                <BodyText>
                  With my background as an educator, as well as a mother of a
                  successful family, I have developed a unique approach to
                  raising happy, healthy, and successful kids. The key is to
                  empower children to come up with their own ideas and make
                  decisions for themselves.
                </BodyText>
                <BodyText>
                  Through the TRICK method, which stands for
                  <div style={{ fontWeight: "bold" }}>Trust</div>
                  <div style={{ fontWeight: "bold" }}>Respect</div>
                  <div style={{ fontWeight: "bold" }}>Independence</div>
                  <div style={{ fontWeight: "bold" }}>Collaboration</div>
                  <div style={{ fontWeight: "bold" }}>Kindness</div>
                  Parents can create a nurturing and supportive environment for
                  their children to thrive.
                </BodyText>
                <BodyText>
                  The TRICK app is designed to guide parents through this
                  process, offering valuable resources, tips, and strategies for
                  implementing the method in their everyday lives.
                </BodyText>
                <BodyText>
                  Join me on this journey and discover how you can raise
                  successful and fulfilled individuals with the help of TRICK!
                </BodyText>
                <h1 style={{ fontWeight: 700, fontSize: "28px" }}>
                  How It Works
                </h1>
                <BodyText>
                  * Receive a new Parenting T.R.I.C.K lesson weekly in the Learn
                  menu
                </BodyText>
                <BodyText>
                  * Complete the Summary, Reflect, Activities and Review to
                  finish the lesson and unlock points, badges and certificates
                </BodyText>
                <BodyText>
                  * New lessons are available every week or once completed
                </BodyText>
                <BodyText>
                  * Chat with Esther anytime to ask her about anything related
                  to parenting and T.R.I.C.K
                </BodyText>
                <BodyText>
                  * Check your Progress to see your achievements in learning the
                  Parenting T.R.I.C.K method
                </BodyText>
                <h1 style={{ fontWeight: 700, fontSize: "28px" }}>
                  About Esther
                </h1>
                <BodyText>
                  Esther Wojcicki is a leading American educator, journalist,
                  and mother. Leader in Blending Learning and the integration of
                  technology into education, she is the founder of the Media
                  Arts program at Palo Alto High School, where she built a
                  journalism program from a small group of 20 students in 1984
                  to one of the largest in the nation including 600 students,
                  five additional journalism teachers, and nine award-winning
                  journalism publications. Wojcicki co-founded Tract, an online
                  community where kids teach kids through multimedia, with her
                  former student and serves as its Chief Learning Officer.
                </BodyText>
                <BodyText>
                  Wojcicki also serves as Vice Chair of Creative Commons and has
                  previously worked as a professional journalist for multiple
                  publications and blogs regularly for The Huffington Post.
                </BodyText>
                <BodyText>
                  Esther has been intimately involved with Google and GoogleEdu
                  since its inception, where she was one of the leaders in
                  setting up the Google Teacher Academy and remains a guiding
                  force. With three Honorary Doctorate Degrees – Palo Alto
                  University (2013), Rhode Island School of Design (2016), and
                  University of Brazilia (2018). She was California Teacher of
                  the Year in 2002 by the California Commission on Teacher
                  Credentialing; a recipient of the Gold Key by Columbia
                  Scholastic Press Association in recognition of her outstanding
                  devotion to the cause of the school press; a board member of
                  Alliance for Excellent Education in Washington, DC, and on the
                  board of Newseum in DC; and a has been a consultant for the
                  U.S Department of Education, Hewlett Foundation, Carnegie
                  Foundation for Advancement of Teaching, Google, Silicon Valley
                  Education Foundation and Time Magazine Education.
                </BodyText>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <IOSBadge
                    onClick={() => {
                      window.open(
                        "https://apps.apple.com/us/app/parenting-trick/id6472183489",
                        "_blank"
                      );
                    }}
                  />
                  <GooglePlayBadge
                    style={{ marginLeft: "20px" }}
                    onClick={() => {
                      window.open(
                        "https://play.google.com/store/apps/details?id=com.agentwire.parentingtrick",
                        "_blank"
                      );
                    }}
                  />
                </div>
                <div>
                  <h1 style={{ fontWeight: 700, fontSize: "28px" }}>
                    Deleting Your Account
                  </h1>
                  <BodyText>
                    If you would like to delete your account, please email us at
                    support@agentwire.ai from the email address associated with
                    your account or login to your account within the app and go
                    to Profile -&gt; Settings and click on Delete Account. All
                    of your data will be deleted, including your lesson
                    progress, points, badges and certificates, as well as your
                    chat history with Esther.
                  </BodyText>
                </div>
              </div>
            </div>
          </div>
          <FooterAuth {...footerauth} />
        </section>
      </main>
    </>
  );
};

export default ParentingTrick;
